import { render, staticRenderFns } from "./MediaWord.vue?vue&type=template&id=071a78e6&scoped=true"
import script from "./MediaWord.vue?vue&type=script&lang=js"
export * from "./MediaWord.vue?vue&type=script&lang=js"
import style0 from "./MediaWord.vue?vue&type=style&index=0&id=071a78e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a78e6",
  null
  
)

export default component.exports